import React from 'react';
import Header from '../../components/Header';
import { Footer } from '../../components/Footer';

export default function PrivacyPage() {
  const stripedBg = {
    backgroundImage: 'repeating-linear-gradient(-45deg, var(--bg-stripe), var(--bg-stripe) 2px, var(--bg-body) 2px, var(--bg-body) 10px)',
    backgroundColor: 'var(--bg-body)'
  };

  const sections = [
    { 
      id: "1", 
      title: "Consent to Privacy Policy", 
      text: "By accessing and using our platform, you signify your acceptance and agreement to be bound by the terms of this Privacy Policy. If you do not agree, please do not use our services." 
    },
    { 
      id: "2", 
      title: "Information Collection and Personally Identifiable Information", 
      text: "We collect various personal data including registration data (name, email), usage data, and marketing data. This information is used to manage your account, process payments, and improve your overall learning experience. You have the right to access, update, or request the deletion of your data at any time." 
    },
    { 
      id: "3", 
      title: "Information Use", 
      text: "Your data helps us personalize your dashboard, conduct internal research, and provide technical support. We also use your contact information to send important updates about your account and the courses you are enrolled in." 
    },
    { 
      id: "4", 
      title: "Information Sharing and Disclosure", 
      text: "We do not sell your personal data. We only share information with third-party service providers (like payment processors) necessary to operate the platform, or when required by legal authorities." 
    },
    { 
      id: "5", 
      title: "Changing or Deleting Your Information", 
      text: "You can review and update your personal information through your profile settings. If you wish to permanently delete your account and associated data, please contact our support team." 
    },
    { 
      id: "6", 
      title: "Use of Cookies and Similar Technologies", 
      text: "We use cookies to enhance navigation, remember your preferences, and analyze site traffic. You can choose to disable cookies through your browser settings, though some features of the site may not function correctly." 
    },
    { 
      id: "7", 
      title: "Behavioral Advertising and Online Privacy", 
      text: "We may use third-party tools to display relevant advertisements to you based on your interests. You can manage your preferences regarding online advertising through industry-standard opt-out tools." 
    },
    { 
      id: "8", 
      title: "Changes and Updates", 
      text: "We may periodically update this policy. We will notify you of any significant changes by posting the updated version on this page and updating the effective date below." 
    }
  ];

  return (
    <div style={stripedBg} className="min-h-screen w-full py-2 px-2 sm:py-8 sm:px-4 md:px-8 lg:px-12 flex justify-center font-sans text-slate-900 overflow-hidden">
      
      <div className="w-full bg-[var(--bg-box)] rounded-[1.5rem] md:rounded-[2.5rem] overflow-hidden border border-[var(--border-200)] flex flex-col relative shadow-sm">
        <Header />  

        <main className="flex-grow">
          
          {/* --- MAIN CONTENT CARD --- */}
          <section className="py-10 sm:py-16 md:py-24 px-2 sm:px-4 md:px-6 flex justify-center">
            <div className="w-full max-w-4xl bg-white rounded-xl md:rounded-[2rem] border border-gray-200 p-4 sm:p-8 md:p-10 lg:p-20 shadow-sm">
              
              {/* Card Header (Matching Terms Design) */}
              <div className="mb-12">
               
                <h1 className="text-4xl md:text-5xl font-extrabold text-[#2b3543] tracking-tight">
                  Privacy Policy
                </h1>
                <p className="mt-6 text-slate-500 font-medium text-lg leading-relaxed">
                  We are committed to protecting your privacy. This policy explains how we collect, use, and safeguard your personal information when you use our platform.
                </p>
                <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mt-4">
                  Last updated: March 2026
                </p>
              </div>

              {/* Sections List */}
              <div className="space-y-12">
                {sections.map((item) => (
                  <div key={item.id} className="border-t border-gray-100 pt-8">
                    <h2 className="text-xl font-extrabold text-[#2b3543] mb-4">
                      {item.id}. {item.title}
                    </h2>
                    <p className="text-slate-500 leading-relaxed font-medium">
                      {item.text}
                    </p>
                  </div>
                ))}

                {/* Contact Section */}
                <div className="border-t border-gray-100 pt-8">
                  <h2 className="text-xl font-extrabold text-[#2b3543] mb-4">
                    9. Contact
                  </h2>
                  <p className="text-slate-500 leading-relaxed font-medium">
                    If you have any questions or concerns regarding our privacy practices, please contact us at: <br/>
                    <a href="mailto:support@LearnAISocial.net" className="text-[#2b3543] font-bold underline underline-offset-4 decoration-orange-400">
                      support@LearnAISocial.net
                    </a>
                  </p>
                </div>
              </div>

            </div>
          </section>

     

        </main>

        <Footer />
      </div>
    </div>
  );
}